<template>
  <div class="col-md-12">
    <form name="newDocument" @submit.prevent="handleSubmit()">
      <div class="modal-body">
        <label>Type:</label>

        <select name="Type" v-model="encodingData.Type" class="form-control">
          <option value>Select Type</option>
          <option
            v-for="option in types"
            v-bind:value="option.paperType"
            v-bind:key="option.paperType"
          >{{option.paperType}}</option>
        </select>

        <label>ReferenceNo :</label>

        <input name="ReferenceNo"
        v-validate="'max:50'"
        v-model="encodingData.ReferenceNo" 
        class="form-control"
        :class="{ 'is-invalid': submitted && errors.has('ReferenceNo') }" />
            <span v-if="submitted && errors.has('ReferenceNo')"
                         class="invalid-feedback">
                        {{ errors.first("ReferenceNo") }}
            </span>

        <label>IssuingAgency :</label>

        <input name="IssuingAgency"
         v-model="encodingData.IssuingAgency"
         v-validate="'max:50'"
         class="form-control" 
         :class="{ 'is-invalid': submitted && errors.has('IssuingAgency') }" />
            <span v-if="submitted && errors.has('IssuingAgency')"
                         class="invalid-feedback">
                        {{ errors.first("IssuingAgency") }}
            </span>

        <label>IssuanceDate :</label>

        <input
          type="date"
          name="IssuanceDate"
          v-model="encodingData.IssuanceDate"
          class="form-control"
        />

        <label>Country:</label>

        <select name="Country" v-model="encodingData.Country" class="form-control">
          <option value>Select Country</option>
          <option
            v-for="option in countries"
            v-bind:value="option.countryName"
            v-bind:key="option.countryName"
          >{{option.countryName}}</option>
        </select>

        <label>State:</label>

        <select name="SourceId" v-model="encodingData.State" class="form-control">
          <option value>Select State</option>
          <option
            v-for="option in provinces"
            v-bind:value="option.province"
            v-bind:key="option.province"
          >{{option.province}}</option>
        </select>

        <label>City :</label>

        <input type="text" name="City" v-model="encodingData.City" class="form-control" />

        <label>Address :</label>

        <input type="text" 
        name="City" 
        v-model="encodingData.Address" 
        v-validate="'max:200'"
        class="form-control" 
        :class="{ 'is-invalid': submitted && errors.has('Address') }" />
            <span v-if="submitted && errors.has('Address')"
                         class="invalid-feedback">
                        {{ errors.first("Address") }}
            </span>

        <label>Comments :</label>

        <textarea
          name="Comments"
          v-model="encodingData.Comments"
          rows="5"
          cols="5"
          class="form-control"
        />

        <label>Last Name :</label>

        <input type="text"
        v-validate="'max:200'" 
        name="LastName" 
        v-model="encodingData.LastName" 
        class="form-control"
        :class="{ 'is-invalid': submitted && errors.has('LastName') }" />
            <span v-if="submitted && errors.has('LastName')"
                         class="invalid-feedback">
                        {{ errors.first("LastName") }}
            </span>

        <label>First Name :</label>

        <input type="text"
        v-validate="'max:200'"  
        name="FirstName" 
        v-model="encodingData.FirstName" 
        class="form-control"
        :class="{ 'is-invalid': submitted && errors.has('FirstName') }" />
            <span v-if="submitted && errors.has('FirstName')"
                         class="invalid-feedback">
                        {{ errors.first("FirstName") }}
            </span>

        <label>Middle Name :</label>

        <input type="text"
        v-validate="'max:200'"  
        name="MiddleName" 
        v-model="encodingData.MiddleName" 
        class="form-control"
        :class="{ 'is-invalid': submitted && errors.has('MiddleName') }" />
            <span v-if="submitted && errors.has('MiddleName')"
                         class="invalid-feedback">
                        {{ errors.first("MiddleName") }}
            </span>

        <label>Country:</label>

        <select name="BirthCountry" v-model="encodingData.BirthCountry" class="form-control">
          <option value>Select Birth Country</option>
          <option
            v-for="option in countries"
            v-bind:value="option.countryName"
            v-bind:key="option.countryName"
          >{{option.countryName}}</option>
        </select>

        <label>BirthDate :</label>

        <input type="date" name="BirthDate" v-model="encodingData.BirthDate" class="form-control" />
      </div>

      <div class="modal-footer">
        <button type="submit" class="btn btn-primary">Save</button>
      </div>
    </form>
  </div>
</template>

<script>

import {
  authHeader,
  responseCheck,
  notifyHelper,
  EncodeURL,
  DataURL,
  getlocalstorageCountry,
  getlocalstorageProvince,
  getlocalstoragePaperType,
  formatdate
} from '../../helper'
import instance from '../../helper/http'
export default {
  data() {
    return {
      encodingData: {
        PaperId: '',
        Type: '',
        ReferenceNo: '',
        IssuingAgency: '',
        IssuanceDate: null,
        Country: '',
        State: '',
        City: '',
        Address: '',
        Comments: '',
        LastName: '',
        FirstName: '',
        MiddleName: '',
        BirthCountry: '',
        BirthDate: null
      },
      countries: [],
      provinces: [],
      types: []
    }
  },
  created: function() {
    this.getlibs()
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  methods: {
    getlibs() {
      
      this.countries = getlocalstorageCountry()
      this.provinces = getlocalstorageProvince()
      this.types = getlocalstoragePaperType()
      
      this.getPaper()
    },
    handleSubmit() {
      let loader = this.$loading.show()
      instance
        .post(EncodeURL + 'updateOfficialPapers', this.encodingData, {
          headers: authHeader()
        })
        .then(response => {
          if (response.data.error) {
            loader.hide()
            notifyHelper('error', response.data.message)
          } else {
            loader.hide()
            notifyHelper('success', response.data.message)
            this.$emit('done-edit-paper')
          }
        })
        .catch(function (error) {
          responseCheck(error.response.status);
        })
    },
    getPaper() {
      
      instance
        .get(DataURL + 'papers?officialpapersID=' + this.id, {
          headers: authHeader()
        })
        .then(response => {
          if (response.data.error === false) {
            if (response.data.withdata) {
              let data = response.data.data
              this.encodingData.PaperId = data.paperId
              this.encodingData.Type = data.type
              this.encodingData.ReferenceNo = data.referenceNo
              this.encodingData.IssuingAgency = data.issuingAgency
              this.encodingData.IssuanceDate = formatdate(data.issuanceDate)
              this.encodingData.Country = data.country
              this.encodingData.State = data.state
              this.encodingData.City = data.city
              this.encodingData.Address = data.address
              this.encodingData.Comments = data.comments
              this.encodingData.LastName = data.lastName
              this.encodingData.FirstName = data.firstName
              this.encodingData.MiddleName = data.middleName
              this.encodingData.BirthCountry = data.birthCountry
              this.encodingData.BirthDate = formatdate(data.birthDate)
            }
          }
        })
        .catch(function (error) {
          responseCheck(error.response.status);
        })
    }
  }
}
</script>
